import React, { useContext, useEffect } from "react";
import "./HomeScreen.css";
import { ScreenContext } from "./App";
import backgroundImage from "./Assets/Images/AppDashboard/HomeScreen/HomeScreenBG.png";
import playerProfile from "./Assets/Images/AppDashboard/HomeScreen/PlayerProfile.png";
import profileEditIcon from "./Assets/Images/AppDashboard/HomeScreen/editIcon.png";

//tier
import tierBG from "./Assets/Images/AppDashboard/HomeScreen/tier-bg.png";

//coin
import coinBar from "./Assets/Images/AppDashboard/HomeScreen/coinBar.png";

import PlayerSelectionScreen from "./PlayerSelectionScreen";
import {
  setSelectedGameModeExport,
  handleZIndexChangeExport,
} from "./PlayerSelectionScreen";

import Loading from "./Loading";
import { handleZIndexChangeLoadingExport } from "./Loading";

import LobbyScreen from "./LobbyScreen";

// Setting Screen

import SettingScreen from "./SettingScreen";
import { handleSettingZIndexChangeExport } from "./SettingScreen";

const HomeScreen = () => {
  const handleScreenChange = useContext(ScreenContext);

  useEffect(() => {
    // Call handleZIndexChangeLoadingExport only once after successful loading
    handleZIndexChangeLoadingExport(1100);
  }, []); // Empty dependency array ensures the effect runs only once after mounting

  const QuickPlayMode = () => {
    StartGame("QUICK");
  };

  const SinglePlayMode = () => {
    StartGame("SINGLE");
  };

  const MutliPlayMode = () => {
    return;
    StartGame("MULTI");
  };

  const OpenSettingScren = () => {
    // handleScreenChange('Setting');
    handleSettingZIndexChangeExport();
  };

  const StartGame = async (gameMode) => {
    console.log(`Setting Selected Game Mode ====> ${gameMode} || HomeScreen`);

    handleZIndexChangeExport(999);
    handleZIndexChangeLoadingExport();
    await handleScreenChange("PlayerSelection"); // Change to the 'Game' screen
    setSelectedGameModeExport(gameMode);
  };

  return (
    <div className="home-screen">
      <img
        src={backgroundImage}
        alt="Background"
        className="background-image"
      />

      <div>
        {/* Player Selection Screen */}
        {/* Render Player Selection Screen */}
        {<PlayerSelectionScreen />}
      </div>

      <div>
        {/* LobbyScreen */}
        {<LobbyScreen />}
      </div>

      <div>
        {/* LoadingScreen */}
        {<Loading />}
      </div>

      <div>{<SettingScreen />}</div>



      <div className="tier-bar">
        <img src={tierBG} alt="Player" className="profile-image" />
        <div className="tier-font">TIER</div>
        <div className="tier-center">0</div>
      </div>

      <div className="top-right-container">
        <img src={coinBar} alt="Image" className="top-right-image" />
        <div className="centered-text top-right-font">10000</div>
      </div>

      {/*<div className="coin-bar-container">
  
    <img src={coinBar} alt="Player" className="coin-bar-image"/>
    <div className="coin-text">10000</div>
 
</div> */}

      <div className="player-profile">
        <img src={playerProfile} alt="Player" className="profile-image" />
        <i
          className="edit-icon fas fa-edit"
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        ></i>
        <img
          src={profileEditIcon}
          alt="Edit Icon"
          className="edit-icon"
          style={{
            width: "3.5%",
            height: "auto",
            position: "absolute",
            left: "18%",
            top: "20%",
            transform: "translate(-50%, -50%)",
          }}
        />
        <div
          style={{
            position: "absolute",
            left: "10%",
            top: "-15%",
            width: "100%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "white",
            fontSize: "2.5vw",
            fontFamily: "Gomarice",
          }}
        >
          GUEST
        </div>
      </div>

      <img
        src={require("./Assets/Images/AppDashboard/HomeScreen/QuickPlayerBtn.png")}
        alt="Quick Play Button"
        className="quick-play"
        onClick={QuickPlayMode}
      />

      <img
        src={require("./Assets/Images/AppDashboard/HomeScreen/SinglePlayerBtn.png")}
        alt="Single Play Button"
        className="single-play"
        onClick={SinglePlayMode}
      />

      <img
        src={require("./Assets/Images/AppDashboard/HomeScreen/MultiPlayerBtn.png")}
        alt="Multi Play Button"
        className="multi-play"
        onClick={MutliPlayMode}
      />

      {/*<img src="./image1.jpg" alt="" className="upper-left-image"/> */}

      <img
        src={require("./Assets/Images/AppDashboard/HomeScreen/setting.png")}
        alt="Setting Button"
        className="setting-icon"
        onClick={OpenSettingScren}
      />

      <img
        src={require("./Assets/Images/AppDashboard/HomeScreen/help.png")}
        alt="Help Button"
        className="help-icon"
      />

      <img
        src={require("./Assets/Images/AppDashboard/HomeScreen/inventory.png")}
        alt="Inventroy Button"
        className="inventory-icon"
      />

      <img
        src={require("./Assets/Images/AppDashboard/HomeScreen/store.png")}
        alt="Store Button"
        className="store-icon"
      />
    </div>
  );
};

export default HomeScreen;